import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useAuth } from '../contexts/AuthContext';

const { FiLogOut } = FiIcons;

const LogoutButton = () => {
  const { signOut } = useAuth();
  const { t } = useTranslation();

  return (
    <motion.button
      onClick={signOut}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      className="flex items-center gap-2 px-4 py-2 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors"
    >
      <SafeIcon icon={FiLogOut} />
      <span>{t('logout.button')}</span>
    </motion.button>
  );
};

export default LogoutButton;